import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { CarsState } from '../../types';

import { getT4EObuDevices } from '../operations/getT4EObuDevices';

import { STATUS_LOADING } from 'common/constants';

export const setT4EboxDevices = (builder: ActionReducerMapBuilder<CarsState>) =>
  builder
    .addCase(getT4EObuDevices.pending, (state) => {
      state.t4EboxDevices.loadingStatus = STATUS_LOADING.load;
    })
    .addCase(getT4EObuDevices.fulfilled, (state, { payload }) => {
      state.t4EboxDevices.loadingStatus = STATUS_LOADING.done;
      state.t4EboxDevices.data = payload;
    })
    .addCase(getT4EObuDevices.rejected, (state) => {
      state.t4EboxDevices.loadingStatus = STATUS_LOADING.error;
    });
